const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function dateParts(iso) {
  if (!iso) return { day: '--', mo: '---' };
  // Treat YYYY-MM-DD as a *local* date (no timezone shift).
  const [y, m, d] = String(iso).slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return { day: '--', mo: '---' };
  return { day: String(d).padStart(2, '0'), mo: MONTHS[m - 1] };
}

function timeRange(start, end) {
  if (!start && !end) return null;
  if (start && end) return `${start} – ${end}`;
  return start || end;
}

/**
 * One event row. Matches `.event` + `.event-date` markup from event.html.
 *
 *   item: { eventDate, startTime?, endTime?, title, location?, description?, image? }
 */
export function EventCard({ item }) {
  const { day, mo } = dateParts(item.eventDate);
  const time = timeRange(item.startTime, item.endTime);
  return (
    <article className="event">
      <div className="event-date">
        <div className="day">{day}</div>
        <div className="mo">{mo}</div>
      </div>
      <div>
        <h3>{item.title}</h3>
        <div className="when">
          {time && <span>{time}</span>}
          {item.location && <span>{item.location}</span>}
        </div>
        {item.description && <p>{item.description}</p>}
      </div>
    </article>
  );
}
